<cobalt-layout>
  <ng-container cobaltLayoutHeader>
    <app-header [sideNavigationRef]="sideNavigationRef"></app-header
  ></ng-container>
  <ng-container cobaltLayoutNavigation>
    <cobalt-side-navigation
      #sideNavigationRef
      applicationName="Crew Training"
      class="basic-side-nagivation"
      data-testid="parentContainerMainMenu"
    >
      <a
        *ngFor="let navItem of menuItems"
        cobaltSideNavigationItem
        [routerLink]="navItem.routerLink"
        [activated]="isActive(navItem.routerLink)"
      >
        <cobalt-icon
          *ngIf="navItem.iconName"
          size="medium"
          [name]="
            navItem.iconName +
            (isActive(navItem.routerLink) ? '-solid' : '-outline')
          "
        ></cobalt-icon>
        {{ navItem.label }}
      </a>
      <ng-container cobaltSideNavigationFooter>
        <a
          cobaltSideNavigationItem
          (click)="satisfactionSurveyClicked()"
          data-testid="survey"
        >
          <cobalt-icon size="medium" name="feedback-outline"></cobalt-icon
          >Satisfaction Survey
        </a>
        <a cobaltSideNavigationItem (click)="helpClicked()" data-testid="help">
          <cobalt-icon size="medium" name="help-circle-outline"></cobalt-icon
          >Help
        </a>
      </ng-container>
    </cobalt-side-navigation>
  </ng-container>
  <ng-container cobaltLayoutContent>
    <app-banner></app-banner>
    <router-outlet></router-outlet>
  </ng-container>
</cobalt-layout>

<app-loading-circular-panel></app-loading-circular-panel>
